import { Box, Card, Grid, Typography } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import { useState } from "react";
import DadosPessoalEdit from "../dadosGenericos/dadosPessoalEdit";
import DirectorTecnicoEdit from "../dadosGenericos/directorTecnicoEdit";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import FotoEdit from "../../utils/fotoEdit";
import Delete from "../../utils/delete";
import DirectorTecnicoCreateRepresentante from "./directorTecnicoCreateRepresentante";


export default function FichaDirectorTecnico({ directorTecnico, header, menu, setRefresh }) {
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [editDados, setEditDados] = useState(false)
    const [openEditFoto, setOpenEditFoto] = useState(false)
    const [dadosDirectorTecnico, setdirectorTecnico] = useState(directorTecnico)
    const [open, setOpen] = useState(false);
    const [openDTCR, setOpenDTCR] = useState(false);
    // console.log(directorTecnico)


    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );

    return (
        <>
            {directorTecnico ?

                <Card style={{ padding: 20, minHeight: '20vh', marginTop: 20 }}>
                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}

                    <Delete
                        open={open}
                        setOpen={setOpen}
                        url={'/director-tecnico/delete'}
                        msg={`Tem certeza que deseja eliminar Director(a) Técnico(a) ${directorTecnico?.dadosPessoais?.nome}`}
                        id={directorTecnico._id}
                    />

                    <DirectorTecnicoCreateRepresentante
                        open={openDTCR}
                        setOpen={setOpenDTCR}
                        directorTecnico={directorTecnico}
                    />

                    {header &&
                        <HeaderGestorConfigs
                            menu={menu ?? true}
                            configArea={'fichaDT'}
                            title={editDados ? 'EDITAR DADOS' : 'FICHA DE DIRECTOR TÉCNICO'}
                            directorTecnico={directorTecnico}
                            editDados={editDados}
                            setEditDados={setEditDados}
                            directorTecnicoCreateRepresentante={setOpenDTCR}
                            delete={setOpen}
                        />
                    }

                    {!editDados &&

                        <Grid container>
                            <Grid item marginRight={2}>
                                <FotoEdit
                                    openEditFoto={openEditFoto}
                                    setOpenEditFoto={setOpenEditFoto}
                                    dadosPessoal={directorTecnico?.dadosPessoais}
                                />
                            </Grid>

                            <Grid xs item >
                                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                                    <Grid container spacing={2}>
                                        {/* {renderField('Estado', directorTecnico?.dadosPessoais.status)} */}
                                        {renderField('Nome', directorTecnico?.dadosPessoais.nome)}
                                        {renderField('B.I', directorTecnico?.dadosPessoais.numeroBI)}
                                        {renderField('Carteira', directorTecnico?.numeroCarteira)}
                                        {renderField('Ordem', directorTecnico?.ordem)}
                                        {renderField('Categoria', directorTecnico?.categoria?.designacao)}
                                        {renderField('Telefone1', directorTecnico?.dadosPessoais?.tel1)}
                                        {renderField('Telefone2', directorTecnico?.dadosPessoais?.tel2)}

                                        {renderField('E-mail', directorTecnico?.dadosPessoais.email)}
                                        {renderField('Provincia', directorTecnico?.dadosPessoais.provincia)}
                                        {renderField('Município', directorTecnico?.dadosPessoais.municipio)}
                                        {renderField('Bairro', directorTecnico?.dadosPessoais.bairro)}
                                        {renderField('Rua / Avenida', directorTecnico?.dadosPessoais.rua)}
                                        {renderField('Nacionalidade', directorTecnico?.dadosPessoais.nacionalidade)}
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                    }

                    {(editDados === 'dadospessoaledit' || editDados === 'all') &&
                        <DadosPessoalEdit
                            dadosPessoais={directorTecnico.dadosPessoais}
                            setDadosPessoais={setdirectorTecnico}
                            cancelEditDados={setEditDados}
                            setRefresh={setRefresh}
                        />
                    }

                    {(editDados === 'dadosdirectortecnicoedit' || editDados === 'all') &&
                        <DirectorTecnicoEdit
                            dadosDirectorTecnico={directorTecnico}
                            setDadosDirectorTecnico={setdirectorTecnico}
                            cancelEditDados={setEditDados}
                            setMessageSuccess={setMessageSuccess}
                            setMessageError={setMessageError}
                            setRefresh={setRefresh}
                        />
                    }
                </Card>
                :
                <Loading />
            }
        </>

    )
}